module.exports = __webpack_public_path__ + "img/logo.84165a2e.png";